import * as cn from "classnames";
import * as moment from "moment";
import * as React from "react";
import * as styles from "./styles.css";
import CalloutLink from "backpack-ui/dist/components/calloutLink";
import CategoryLabelLink from "backpack-ui/dist/components/categoryLabelLink";
import Container from "backpack-ui/dist/components/container";
import GridColumn from "backpack-ui/dist/components/gridColumn";
import GridRow from "backpack-ui/dist/components/gridRow";
import { Heading } from "backpack-ui/dist/components/text";
import { createExcerpt } from "../../utils/createExcerpt";
import { getImgixUrl } from "../../utils/getImgixUrl";
import { truncate } from "../../utils/truncate";
var markup = function (html) { return ({ __html: html }); };
export var PostHighlight = function (_a) {
    var posts = _a.posts;
    return (React.createElement("section", { className: cn("postHighlight", styles.postHighlightContainer) }, posts.map(function (post) { return (React.createElement(Container, null,
        React.createElement("div", null,
            React.createElement(GridRow, null,
                React.createElement(GridColumn, { className: styles.column1, sm: 12, md: 6, fluid: true },
                    React.createElement("div", { className: cn("Article-content", styles.textContainer) },
                        React.createElement(CategoryLabelLink, { href: "/blog/category/lp-pathfinders" }, "Pathfinders"),
                        React.createElement("a", { href: "/blog/" + moment(post.publicationDate).format("YYYY/MM/DD") +
                                "/" + post.metadata.slug, className: styles.anchor },
                            React.createElement(Heading, { weight: "medium", className: styles.heading }, post.title),
                            React.createElement("p", { className: styles.paragraph, dangerouslySetInnerHTML: markup(post.excerpt ?
                                    truncate(post.excerpt, 25) :
                                    createExcerpt(post.content)) }))),
                    React.createElement("footer", { className: styles.footer },
                        React.createElement(CalloutLink, { href: "/blog/" + moment(post.publicationDate).format("YYYY/MM/DD") +
                                "/" + post.metadata.slug }, "Read More"))),
                React.createElement(GridColumn, { className: styles.column2, sm: 12, md: 6, includeGutter: true, fluid: true },
                    React.createElement("div", { className: "Article-image" },
                        React.createElement("img", { src: getImgixUrl(post.featuredImage ?
                                post.featuredImage.url + "?auto=format&fit=crop&w=700&h=500&q=72" :
                                "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=700&h=500&q=72"), alt: "" }))))))); })));
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/postHighlight/index.tsx
// module id = tMiX
// module chunks = 3